/**
 * ミニゲームテンプレート共通hooks
 */
import { useCallback, useMemo, useRef } from 'react';
import { resolveMediaRefToUrl } from '../../utils/mediaRef';

/**
 * ミニゲーム結果送信用hook
 * 二重送信を防止し、ステータスとペイロードをホストに送信
 */
export function useManualSubmit(registryId, templateId, hostSubmit) {
  const submittedRef = useRef(false);
  const submit = useCallback(
    (status, payload = {}) => {
      if (!hostSubmit || submittedRef.current) return;
      submittedRef.current = true;
      hostSubmit({
        status,
        registryId,
        templateId,
        ...payload
      });
    },
    [hostSubmit, registryId, templateId]
  );
  const resetSubmission = useCallback(() => {
    submittedRef.current = false;
  }, []);
  return { submit, resetSubmission };
}

/**
 * 背景スタイル解決用hook
 * hostConfig.background から適切なCSS styleオブジェクトを生成
 */
export function useMinigameBackground(hostConfig) {
  return useMemo(() => {
    const bg = hostConfig?.background;
    if (bg?.type === 'image' && bg.value) {
      const url = resolveMediaRefToUrl(bg.value) ?? bg.value;
      const overlay = bg.overlay ?? 'rgba(2,6,23,0.45)';
      return {
        backgroundColor: '#020617',
        backgroundImage: `linear-gradient(180deg, ${overlay}, rgba(2,6,23,0.9)), url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }
    if (bg?.type === 'color' && bg.value) {
      return { backgroundColor: bg.value };
    }
    return null;
  }, [hostConfig?.background]);
}
